import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import { idZodSchema } from "@@/shared/id";
import { generateId } from "@@/utilities/generate-id";
import type { Except } from "type-fest";
import { z } from "zod";
import { cartZodSchema } from "./cart_old";

const cartVerificationCommandZodSchema = z.object({
    _id: idZodSchema,
    _type: z.literal("CART_VERIFICATION_COMMAND"),
    _createdAt: isoAndUnixZodSchema,
    cart: cartZodSchema,
});

type CartVerificationCommand = z.infer<typeof cartVerificationCommandZodSchema>;

type CartVerificationCommandFactoryParams = Except<
    CartVerificationCommand,
    "_id" | "_type" | "_createdAt"
>;
const cartVerificationCommandFactory = (
    params: CartVerificationCommandFactoryParams,
): CartVerificationCommand => {
    return {
        ...params,
        _id: generateId("cart_verification_command__"),
        _type: "CART_VERIFICATION_COMMAND",
        _createdAt: nowIsoAndUnix(),
    };
};

export { cartVerificationCommandFactory, cartVerificationCommandZodSchema };
export type { CartVerificationCommand, CartVerificationCommandFactoryParams };
